// This is the important part!

const collapseSection = (element) => {
	const sectionHeight = element.scrollHeight
	const elementTransition = element.style.transition
	element.style.transition = ''
	requestAnimationFrame(() => {
		element.style.height = `${sectionHeight}px`
		element.style.transition = elementTransition
		requestAnimationFrame(() => {
			element.style.height = `${0}px`
		})
	})
}

const expandSection = (element) => {
	const allElemements = document.getElementsByClassName('subRowContentContainer')
	const rows = document.getElementsByClassName('benefitGroupRow')
	for (let i = 0; i < allElemements.length; i++) {
		allElemements[i].style.height = '0px'
		allElemements[i].style.borderTop = '0px solid #d8d8d8'
	}

	for (let i = 0; i < rows.length; i++) {
		if (rows[i].classList.contains('cardView')) {
			rows[i].classList.remove('cardView')
		}
	}

	const sectionHeight = element.scrollHeight
	element.style.height = `${sectionHeight}px`
	element.style.borderTop = '1px solid #d8d8d8'
}

const removeCardView = (index) => {
	const row = document.getElementById(`benefitGroupRow${index}`)
	if (row && row.classList.contains('cardView')) {
		row.classList.remove('cardView')
	}
}

const addCardView = (index) => {
	const row = document.getElementById(`benefitGroupRow${index}`)
	if (row) {
		row.classList.add('cardView')
	}
}

const addHeightOnClick = (element) => {
	expandSection(document.getElementById(`subRowContentContainer${element}`))
}

const removeHeightOnClick = (element) => {
	collapseSection(document.getElementById(`subRowContentContainer${element}`))
}

export { removeCardView, addHeightOnClick, removeHeightOnClick, addCardView }
